<template>
  <div class="subtitle-container">
    <h2 class="home-subtitle" :style="styles">
      <slot name="text"></slot>
    </h2>
    <slot name="side"></slot>
  </div>
</template>

<script>
export default {
  props: {
    marginRight: {
      type: Number,
      required: false,
      default: 10
    }
  },
  computed: {
    styles() {
      return `
        ${this.marginRight ? `margin-right: ${this.marginRight}px;` : ''};
      `;
    }
  }
};
</script>

<style lang="scss" scoped>
.subtitle-container {
  display: flex;
  align-items: center;
  @include sm {
    flex-wrap: wrap;
  }
}
.home-subtitle {
  font-size: 1.25em;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
